import { Injectable, Signal } from "@angular/core";
import {
	CreateCompany,
	DeleteCompany,
	DisableCompany,
	EnableCompany,
	UpdateCompany,
	UpdateCompanyDeliveryData,
} from "../command/company.command";
import { Company } from "../model/company.model";
import { UUID } from "../model/entityReference.model";
import { Page } from "../model/query.model";
import { ApiClient } from "../service/network/api.client";
import { CompanyStore } from "../store/company.store";

@Injectable({
	providedIn: "root",
})
export class CompanyApi {
	constructor(
		private readonly api: ApiClient,
		private readonly store: CompanyStore,
	) {}

	public async fetch(id: string): Promise<void> {
		const company = await this.api.get<Company>("/company/" + id);
		this.store.saveCompany(company);
	}

	public async fetchAll(): Promise<void> {
		const page = await this.api.get<Page<Company>>("/company");
		this.store.saveAll(page.content);
	}

	public all(): Signal<Company[]> {
		return this.store.entities;
	}

	public byId(id: UUID): Signal<Company | undefined> {
		this.store.updateById(id);
		return this.store.byIdEntity;
	}

	public syncById(id: UUID): Company | undefined {
		return this.store.syncById(id);
	}

	public async create(command: CreateCompany) {
		await this.api.post("/company/create", command);
		await this.fetch(command.id);
	}

	public async update(command: UpdateCompany) {
		await this.api.post("/company/update", command);
		await this.fetch(command.id);
	}
	public async updateDeliveryData(command: UpdateCompanyDeliveryData) {
		await this.api.post("/company/update-delivery-data", command);
		await this.fetch(command.companyId);
	}
	public async delete(command: DeleteCompany) {
		await this.api.post("/company/delete", command);
		this.store.deleteCompany(command.id);
	}
	public async enable(command: EnableCompany) {
		await this.api.post("/company/enable", command);
		await this.fetch(command.id);
	}
	public async disable(command: DisableCompany) {
		await this.api.post("/company/disable", command);
		await this.fetch(command.id);
	}
}
